import React, { Component } from 'react';
import styles from './styles.scss';
import { connect } from 'react-redux';
import { formatPhoneNumber, addUrlProtocol } from 'utils';
import { withTranslation } from 'react-i18next';

class CollectionsFooter extends Component {
  render() {
    const {
      agency,
      t
    } = this.props;
    return (
      <div className={styles.CollectionsFooterWrap}>
        <div className={styles.CollectionsFooter}>
          <div className={styles.CollectionsFooterLeft}>
            {agency.office ? (
              <div>
                {agency.name ? <p className={styles.CollectionsFooterTitle}>{agency.name}</p> : ''}
                {agency.office[0].address ? <p className={styles.CollectionsFooterText}>
                  {t('components.header.clientHeader.address')}: {agency.office[0].address}</p> : ''
                }
                {agency.office[0].phone ? <p className={styles.CollectionsFooterText}>
                  {t('components.header.clientHeader.phone')}: <a href={`tel:${agency.office[0].phone}`}>{formatPhoneNumber(agency.office[0].phone)}</a></p> : ''}
                {agency.office[0].mail ? <p className={styles.CollectionsFooterText}>
                  {t('components.header.clientHeader.mail')}: <a href={`mailto:${agency.office[0].mail}`}>{agency.office[0].mail}</a></p> : ''}
                {agency.website ? <p className={styles.CollectionsFooterText}>
                  {t('components.header.clientHeader.website')}: <a href={addUrlProtocol(agency.website, 'http')} target={'_blank'}>{agency.website}</a></p> : ''}

              </div>
                        ) : ''}
          </div>
          {/* <div className={styles.CollectionsFooterRight}> */}
          {/* {agency.name ? <p className={styles.CollectionsFooterAgencyName}>{agency.name}</p> : ''} */}
          {/* </div> */}
        </div>
      </div>
    );
  }
}
export default connect(null)(withTranslation()(CollectionsFooter));



// WEBPACK FOOTER //
// ./src/components/Header/ClientHeader/Footer/index.js